module.exports = __webpack_public_path__ + "img/first-component-web.3e7ce96d.png";